import { Component } from 'react';

import { BraxFieldMask, BraxUncontrolledTextField, BraxUncontrolledTextFieldProps } from '../BraxUncontrolledTextField';

export type BraxDateTimeFieldFormats = 'date' | 'time' | 'datetime' | 'month';

export type BraxUncontrolledDateTimeFieldProps = Omit<BraxUncontrolledTextFieldProps, 'value' | 'type' | 'mask'> & {
    value?: string | Date,
    format: BraxDateTimeFieldFormats
};

export class BraxUncontrolledDateTimeField extends Component<BraxUncontrolledDateTimeFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    formats: { [K in BraxDateTimeFieldFormats]: BraxFieldMask } = {
        date: '99/99/9999',
        time: '99:99',
        datetime: '99/99/9999 99:99',
        month: '99/9999'
    };

    render() {
        const { format, value, ...props } = this.props;

        return (
            <BraxUncontrolledTextField
                type="text"
                mask={this.formats[format]}
                value={value instanceof Date ? value.toLocaleString('br') : value}
                {...props}
            />
        );
    }

}
